const API_ORIGIN = (process.env.REACT_APP_API_URL || "http://localhost:3000")
  .replace(/\/api\/?$/, "")
  .replace(/\/$/, "");

function decodeHtmlEntities(value) {
  return value
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&amp;/gi, "&");
}

function toApiAbsolute(src) {
  if (!src) return "";
  if (/^https?:\/\//i.test(src) || /^data:image\//i.test(src) || /^blob:/i.test(src)) return src;
  if (/^\/\//.test(src)) return `https:${src}`;
  if (/^[a-z0-9-]+(\.[a-z0-9-]+)+([/:?#].*)?$/i.test(src)) return `https://${src}`;
  const normalized = src.startsWith("/") ? src : `/${src}`;
  return `${API_ORIGIN}${normalized}`;
}

export function resolveLogoSrc(raw) {
  if (typeof raw !== "string") return "";
  const source = raw.trim();
  if (!source || /^javascript:/i.test(source)) return "";

  if (
    /^data:image\//i.test(source) ||
    /^blob:/i.test(source) ||
    /^https?:\/\//i.test(source) ||
    /^\/\//.test(source)
  ) {
    return toApiAbsolute(source);
  }

  const looksEncodedSvg = /&lt;\s*svg[\s\S]*&lt;\/svg&gt;/i.test(source);
  const decoded = looksEncodedSvg ? decodeHtmlEntities(source) : source;
  const looksLikeSvg =
    /^<svg[\s>]/i.test(decoded) ||
    /^<\?xml[\s\S]*<svg/i.test(decoded) ||
    /<svg[\s\S]*<\/svg>/i.test(decoded);

  if (looksLikeSvg) {
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(decoded)}`;
  }

  return toApiAbsolute(source);
}
